import { Controller } from "stimulus";

export default class extends Controller {
  static targets = [ "textArea", 'counter']

  static values = {
    limit: Number,
    label: String
  }

  connect() {
    this._updateRemainingCharacters();
    this.textAreaTarget.addEventListener("input", this._updateRemainingCharacters.bind(this));
  }

  _updateRemainingCharacters(event) {
    // maxlength stops typing past the limit, but a value that is already longer
    // (imported content, or a limit lowered after the fact) would otherwise
    // render a negative count.
    const value = this.textAreaTarget.value;
    const newlineCount = (value.match(/\n/g) || []).length;
    const count = Math.max(this.limitValue - value.length - newlineCount, 0);

    this.counterTarget.innerHTML = this.labelValue
      ? this.labelValue.replace('{count}', count)
      : count;
  }

}
